import { Navigate, useLocation } from 'react-router-dom';
import storage from '../Assets/js/Global';

const is4Life = process.env.REACT_APP_COMPANY_ID === '0it02f';

// require4Life: route only exists for the 4Life company (e.g. /scan-logs,
//   /user-scan-details-four-life) — non-4Life visitors get bounced home even
//   if they hit the URL directly instead of using the (hidden) menu link.
// restrict4Life: the opposite — route is for non-4Life companies only
//   (e.g. /articles, /documents, /ask-ai, /history), so 4Life visitors get
//   bounced home instead.
const ProtectedRoute = ({ children, require4Life, restrict4Life }) => {
    const location = useLocation();
    const loginObj = storage.get('loginObj');

    const isAuthenticated = loginObj && loginObj.userKey;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if ((require4Life && !is4Life) || (restrict4Life && is4Life)) {
        return <Navigate to={is4Life ? '/dashboard2' : '/dashboard'} replace />;
    }

    return children;
};

export default ProtectedRoute;